import { mdiAlertOutline } from '@mdi/js'

export default {
  title: 'Violation',
  to: 'violation-teacher-list',
  icon: mdiAlertOutline,
  resource: 'ViolationTeacher',
  action: 'read',
}
